export default "__VITE_ASSET__740e7fc1__"